import { Component, OnInit } from '@angular/core';
import { MensagemService, ProgressoService } from 'maestro-ng';
import { Frm } from '../../components/frm/frm.interface';
import { Assunto } from '../assunto.model';
import { AssuntoService } from '../assunto.service';

@Component({
  selector: 'app-assunto-frm',
  templateUrl: './assunto-frm.component.html',
  styleUrls: ['./assunto-frm.component.css'],
})
export class AssuntoFrmComponent implements OnInit, Frm<Assunto, number> {
  entidade: Assunto;

  constructor(
    private service: AssuntoService,
    private mensagemService: MensagemService,
    private progressoService: ProgressoService
  ) {}

  ngOnInit(): void {}

  salvar(): void {
    this.progressoService.modal();
    this.service
      .salvar(this.entidade)
      .then((assunto) => {
        this.entidade = assunto;
        this.progressoService.fechar();
        this.mensagemService.addSucesso('Sucesso', 'O assunto foi salvo com sucesso');
      })
      .catch((resposta) => {
        this.progressoService.fechar();
        this.mensagemService.addErro('Erro ao salvar o assunto', resposta.error);
        this.progressoService.fechar();
      });
  }

  iniciarInsercao(): void {
    this.mensagemService.addErro(
      'Erro não implementado',
      'O cadastro de assuntos devem ser realizados via sistema de gestão das entidades TPU!'
    );
  }

  iniciarAlteracao(entidade: Assunto): void {
    this.entidade = entidade;
  }

  iniciarAlteracaoPorId(id: number): void {
    this.progressoService.modal();
    this.service
      .recuperarPorId(id)
      .then((assunto) => {
        this.progressoService.fechar();
        this.iniciarAlteracao(assunto);
      })
      .catch((resposta) => {
        this.progressoService.fechar();
        this.mensagemService.addErro('Erro ao recuperar o assunto para edição', resposta.error);
      });
  }
}
